import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

const statusLabels: Record<string, { text: string; className: string }> = {
    new: { text: 'جدید', className: 'bg-blue-50 text-blue-700 ring-blue-200' },
    pending: { text: 'در حال بررسی', className: 'bg-amber-50 text-amber-700 ring-amber-200' },
    success: { text: 'تایید شده', className: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
    reject: { text: 'رد شده', className: 'bg-red-50 text-red-700 ring-red-200' },
};

export default function CooperationList() {
    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'درخواست همکاری', url: null },
    ];

    return (
        <div className="text-left directions bg-white p-3 m-4 h-[100vh] mb-5">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="درخواست‌های همکاری"></HeaderOfPage>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                <div className="col-span-3">
                    <ListTable />
                </div>
            </div>
        </div>
    );
}

function ListTable() {
    const { t } = useTranslation();
    const cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [page, setPage] = useState(1);
    const [status, setStatus] = useState('');

    const getalldata = async () => {
        try {
            let query = '?page=' + page;
            if (status) query += '&status=' + status;
            const res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/cooperation' + query,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
            });
            setList(res.data.message);
        } catch (error) {
            // ignore
        }
    };

    const deleted = async (id: string) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: 'این درخواست حذف شود؟',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/cooperation/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        },
                    });
                    getalldata();
                } catch (error) {
                    Swal.fire('خطا در حذف');
                }
            }
        });
    };

    const toJalali = (date: string) => {
        return new Date(date).toLocaleString('fa-IR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    useEffect(() => {
        getalldata();
    }, [page, status]);

    const renderStatusBadge = (s: string) => {
        const { text, className } = statusLabels[s] || {
            text: s,
            className: 'bg-gray-50 text-gray-700 ring-gray-200',
        };
        return (
            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ${className}`}>
                {text}
            </span>
        );
    };

    return (
        <div className="directions">
            <div className="mb-4 flex flex-wrap gap-2 items-center">
                <label className="text-sm text-gray-600">وضعیت:</label>
                <select
                    value={status}
                    onChange={(e) => { setPage(1); setStatus(e.target.value); }}
                    className="border border-gray-200 rounded-lg px-3 py-1.5 text-sm"
                >
                    <option value="">همه</option>
                    <option value="new">جدید</option>
                    <option value="pending">در حال بررسی</option>
                    <option value="success">تایید شده</option>
                    <option value="reject">رد شده</option>
                </select>
            </div>

            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">نام</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">مجموعه</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تلفن</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">دسته فعالیت</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تاریخ</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">وضعیت</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.docs.map((item: any) => (
                                        <tr key={item._id || item.id} className="odd:bg-white even:bg-gray-100 hover:bg-gray-100">
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                                {item.fullName}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800">
                                                {item.companyName}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800" dir="ltr">
                                                {item.phone}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800">
                                                {item.activityCategory === 'دیگر' && item.activityCategoryOther
                                                    ? item.activityCategoryOther
                                                    : item.activityCategory}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800">
                                                {toJalali(item.createdAt)}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800">
                                                {renderStatusBadge(item.status)}
                                            </td>
                                            <td className="px-6 text-right py-4 whitespace-nowrap text-sm text-gray-800">
                                                <div className="flex items-center gap-2 justify-end">
                                                    <a href={`/dashboard/Cooperation/list/${item._id || item.id}`}>
                                                        <img src="/icons/eye.svg" width={20} alt="مشاهده" />
                                                    </a>
                                                    <button type="button" onClick={() => deleted(item._id || item.id)}>
                                                        <img src="/icons/trash.svg" width={18} alt="حذف" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="mt-4">
                                <nav className="flex items-center -space-x-px" aria-label="Pagination">
                                    {list != null && list.prevPage != null && (
                                        <button
                                            onClick={() => setPage(list.page - 1)}
                                            type="button"
                                            className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100"
                                        >
                                            {t('Previous')}
                                        </button>
                                    )}
                                    {list != null &&
                                        Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) => (
                                            list.page == item ? (
                                                <button
                                                    key={item}
                                                    type="button"
                                                    className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-200 py-2 px-3 text-sm"
                                                >
                                                    {item}
                                                </button>
                                            ) : (
                                                <button
                                                    key={item}
                                                    onClick={() => setPage(item)}
                                                    type="button"
                                                    className="min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm"
                                                >
                                                    {item}
                                                </button>
                                            )
                                        ))}
                                    {list != null && list.nextPage != null && (
                                        <button
                                            onClick={() => setPage(list.page + 1)}
                                            type="button"
                                            className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100"
                                        >
                                            {t('Next')}
                                        </button>
                                    )}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
